export enum Status {
  active = "active",
  inactive = "inactive",
  ready = "ready",
}

export enum BillStatus {
  overdue = "fällig",
  reminder = "Mahnung",
  closed = "geschlossen",
  canceled = "storniert",
}
